// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2r5tbr0p0vnzC75jDRfyHY"};